module.exports = __webpack_public_path__ + "img/tvbox.b82bb9de.png";